import * as addressesActions from '../actions/addresses.actions';
import { createReducer, on, Action } from '@ngrx/store';
import { AddressApiModel } from 'app/components/map/map.models';

export interface State {
  savedAddress: AddressApiModel;
  loadedAddress: AddressApiModel;
  addresses: AddressApiModel[];
  isLoading: boolean;
  isReady: boolean;
  isSaving: boolean;
}

export const initialState: State = {
  addresses: [],
  savedAddress: null,
  loadedAddress: null,
  isLoading: false,
  isReady: false,
  isSaving: false,
};

const featureReducer = createReducer(
  initialState,
  on(addressesActions.loadAddressesSuccess, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(addressesActions.createAddressSuccess, (state, { address }) => ({
    ...state,
    savedAddress: address,
  })),
  on(addressesActions.resetAddress, () => initialState)
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
